import Vue from "vue";
import App from "./App";
import "./registerServiceWorker";
import router from "./router";
import axios from "axios";

// Global Mixins
import roundInteger from "./mixins/roundInteger";
import roundCurrency from "./mixins/roundCurrency";
import addCommasToInteger from "./mixins/addCommasToInteger";
import moment from "./mixins/moment";

export const eventBus = new Vue();

Vue.config.productionTip = false;

Vue.mixin(roundInteger);
Vue.mixin(roundCurrency);
Vue.mixin(addCommasToInteger);
Vue.mixin(moment);

Vue.prototype.$http = axios

axios.defaults.baseURL = "https://webservices.pslan.net/api/stats/sales/"

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
